import { Stack } from '@mui/material';
import { VyDescriptionTitle } from '../../../../../components/new-design/data-display/VyDescriptionTitle/VyDescriptionTitle';
import { SIZES } from '../../../../../components/types/sizes';
import { SheetWithChartAndArrow } from '@vy/ui-design-system';

export const ReportsPageBanner = () => {
  return (
    <Stack
      sx={{
        alignItems: "center",
        justifyContent: "center",
        padding: '23px',
        background: 'linear-gradient(79deg, #DEE8FF 0.79%, #D9F3EE 107.23%)',
        borderRadius: '5px'
      }}>
      <VyDescriptionTitle
        title="Get the insights you need, when you need them"
        subTitle="Choose a report below to view real-time data or set up scheduled updates - no configuration required."
        size={SIZES.SMALL}
        avatarSx={{ backgroundColor: 'transparent', width: '85px', height: '85px' }}
        icon={<SheetWithChartAndArrow />}
        boldTitle
        cardSx={{
          '& .MuiCardHeader-title': {
            marginBottom: '5px',
          },
          '& .MuiCardHeader-subheader': {
            fontSize: '14px',
            maxWidth: '323px',
          },
        }}
      />
    </Stack>
  );
};
